import { render, staticRenderFns } from "./AccountFormDetails.vue?vue&type=template&id=aa909c06&scoped=true&"
import script from "./AccountFormDetails.vue?vue&type=script&lang=js&"
export * from "./AccountFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccountFormDetails.vue?vue&type=style&index=0&id=aa909c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa909c06",
  null
  
)

export default component.exports